import script from "./AudioEditorOrganism.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioEditorOrganism.vue?vue&type=script&setup=true&lang=ts"

import "./AudioEditorOrganism.vue?vue&type=style&index=0&id=d7b0d8e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7b0d8e6"]])

export default __exports__